var _require = require('../utils/utils'),
    fixedEncodeURIComponent = _require.fixedEncodeURIComponent;

module.exports = function (sparql) {
  var query = fixedEncodeURIComponent(sparql);
  return "https://query.wikidata.org/sparql?format=json&query=".concat(query);
};